function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { useIntl } from "react-intl";
import { ArrowRightIcon, ExternalLinkIcon, InfoIcon, InfoIconWithCircle, WhiteCloseIcon } from "../Molecules/icons";
export var InformationModal = function() {
    var intl = useIntl();
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InformationButton, {
        onClick: function() {
            return setIsOpen(true);
        }
    }), /*#__PURE__*/ React.createElement(Transition, {
        appear: true,
        show: isOpen,
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog, {
        as: "div",
        className: "relative z-10",
        onClose: function() {
            return setIsOpen(false);
        }
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 bg-lightBlack/60"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center text-center overflow-visible full-height-modal  p-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative top-0 scrollable-modal max-h-[890px] self-right"
    }, /*#__PURE__*/ React.createElement("button", {
        "aria-label": "close modal",
        tabIndex: 0,
        onClick: function() {
            return setIsOpen(false);
        },
        className: "hidden md:block absolute top-0 left-[710px] z-50"
    }, /*#__PURE__*/ React.createElement(WhiteCloseIcon, null))), /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95"
    }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
        className: "w-full max-w-2xl  scrollable-modal  max-h-[890px] overflow-auto rounded-[5px] bg-white py-7 px-5 md:p-14 text-left align-middle shadow-xl transition-all"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-green-600 text-[1.75rem] leading-[2.375rem] font-medium mb-5 mt-0",
        tabIndex: 1
    }, intl.formatMessage({
        defaultMessage: "Let's speak to each other, not about each other!",
        id: "un5xW/"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "font-roboto text-base leading-[1.625rem] whitespace-pre-line"
    }, intl.formatMessage({
        defaultMessage: "Campaign description",
        id: "oRM8fC"
    })), /*#__PURE__*/ React.createElement("button", {
        onClick: function() {
            return setIsOpen(false);
        },
        className: "flex flex-row items-center gap-2 py-[1.125rem] px-8 text-white  bg-green-400  font-semibold text-[15px] leading-normal hover:bg-green-600 active:bg-green-600 transition-all duration-200 ease-in-out my-7 rounded-[5px] cursor-pointer self-start font-roboto"
    }, intl.formatMessage({
        defaultMessage: "Zeig mir eine Frage",
        id: "mgpT34"
    }), /*#__PURE__*/ React.createElement(ArrowRightIcon, null)), /*#__PURE__*/ React.createElement("a", {
        href: intl.formatMessage({
            defaultMessage: "Link 1",
            id: "hcXlt0"
        }),
        className: "flex flex-row items-baseline gap-1  text-green-400 hover:text-green-600 active:text-green-600 transition-all duration-200 ease-in-out font-bold text-base font-roboto group relative",
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
        defaultMessage: "Link 1 text",
        id: "ERzGwK"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "block w-0 group-hover:w-full group-active:w-full transition-all duration-200 ease-in-out h-[1px] bg-green-600"
    })), /*#__PURE__*/ React.createElement(ExternalLinkIcon, null)), /*#__PURE__*/ React.createElement("a", {
        href: intl.formatMessage({
            defaultMessage: "Link 2",
            id: "PjRbR1"
        }),
        className: "flex flex-row items-baseline gap-1  text-green-400 hover:text-green-600 active:text-green-600 transition-all duration-200 ease-in-out font-bold text-base font-roboto group relative ",
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
        defaultMessage: "Link 2 text",
        id: "/HzeKf"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "block w-0 group-hover:w-full group-active:w-full transition-all duration-200 ease-in-out h-[1px] bg-green-600"
    })), /*#__PURE__*/ React.createElement(ExternalLinkIcon, null)), /*#__PURE__*/ React.createElement("p", {
        className: "text-base leading-[1.625rem] font-roboto py-[1.125rem]"
    }, intl.formatMessage({
        defaultMessage: "Inclusion is in everyone's interest",
        id: "DAic9k"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "text-base leading-[1.625rem] font-roboto"
    }, intl.formatMessage({
        defaultMessage: "Find out more",
        id: "1eP3ff"
    })), /*#__PURE__*/ React.createElement("a", {
        href: intl.formatMessage({
            defaultMessage: "https://www.heks.ch/inklusion",
            id: "j01SfB"
        }),
        className: "flex flex-row items-baseline gap-1  text-green-400 hover:text-green-600 active:text-green-600 transition-all duration-200 ease-in-out font-bold text-base font-roboto group relative",
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
        defaultMessage: "Wann f\xfchlst du dich als Teil der Schweiz? (heks.ch)",
        id: "wRXzP+"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "block w-0 group-hover:w-full group-active:w-full transition-all duration-200 ease-in-out h-[1px] bg-green-600"
    })), /*#__PURE__*/ React.createElement(ExternalLinkIcon, null)), /*#__PURE__*/ React.createElement("h3", {
        className: "text-green-600 text-[1.75rem] leading-[2.375rem] font-medium mb-5 mt-8"
    }, "Newsletter"), /*#__PURE__*/ React.createElement("p", {
        className: "text-base leading-[1.625rem] font-roboto"
    }, intl.formatMessage({
        defaultMessage: "Newsletter description",
        id: "viCfxx"
    })), /*#__PURE__*/ React.createElement("a", {
        href: intl.formatMessage({
            defaultMessage: "https://www.heks.ch/heks-newsletter",
            id: "d1vipv"
        }),
        target: "_blank",
        rel: "noreferrer",
        className: "flex flex-row items-center gap-2 py-[1.125rem] px-8 text-white  bg-green-400  font-semibold text-[15px] leading-normal hover:bg-green-600  active:bg-green-600 transition-all duration-200 ease-in-out my-7 rounded-[5px] cursor-pointer self-start font-roboto"
    }, intl.formatMessage({
        defaultMessage: "Newsletter link text",
        id: "uLm9eK"
    }), /*#__PURE__*/ React.createElement(ArrowRightIcon, null))))))))));
};
var InformationButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: " hidden md:flex group gap-3.5 flex-row py-3.5 ps-5 pe-7 rounded-[5px]  border-white border-[2.5px] text-white font-semibold  text-[15px] bg-green-500 hover:bg-white hover:text-green-600  active:bg-white active:text-green-600 transition-all duration-200 ease-in-out",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(InfoIcon, null), "Information"), /*#__PURE__*/ React.createElement("button", {
        className: "block md:hidden group",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement(InfoIconWithCircle, null)));
};
